import { useCallback, useEffect } from "react";
import { ResponseData } from "@api/internal/utils/types";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import { useDelayedComponents } from "@hooks/useDelayedComponents";
import { FeedSetReadingHistoryResponse } from "@routes/MyAccount/utils/types";
import axios from "axios";

type useSetReadingHistoryProps = {
  /** Article id to set the reading history  */
  articleId: string;
};

/**
 * Hook to set reading history for a user.
 */
export const useSetReadingHistory = ({
  articleId,
}: useSetReadingHistoryProps) => {
  const { visitorId } = useUserInfo();
  const { isShown } = useDelayedComponents(800);

  const sendReadingHistoryData = useCallback(
    async (articleId: string) => {
      const payload = {
        articleId: articleId,
      };

      const response = await axios
        .post<ResponseData<FeedSetReadingHistoryResponse>>(
          "/_plat/api/v1/user/reading-history",
          payload,
          {
            headers: {
              aovisitorid: visitorId,
            },
          }
        )
        .then((data) => data.data);

      if (!response.success) {
        // eslint-disable-next-line no-console
        console.error(
          `Error setting reading history - ${JSON.stringify({ payload, response })}`
        );
      }
    },
    [visitorId]
  );

  useEffect(() => {
    if (!isShown) return;
    if (typeof articleId !== "string") return;
    if (!visitorId) return;

    sendReadingHistoryData(articleId);
  }, [sendReadingHistoryData, articleId, visitorId, isShown]);
};
